import { useMutation } from '@tanstack/react-query';
import { deletarAgendamentoApi } from '../api/DeletarAgendamentoApi';
import type { DeletarAgendamentoPayload } from '../types';

export function useDeletarAgendamento() {
  return useMutation<void, Error, DeletarAgendamentoPayload>({
    mutationFn: deletarAgendamentoApi,
  });
}
